import XIcon from "@redotech/redo-icons/x-close.svg";
import { ProcessReturnStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import * as inspectorStyles from "@redotech/redo-web/inspector.module.css";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import {
  FrontendStepType,
  PartialWithRequiredType,
  StepTypeDetailsProps,
} from "../steps";

const ProcessReturnInspector = memo(function ProcessReturnInspector(
  props: StepTypeDetailsProps<PartialWithRequiredType<ProcessReturnStep>>,
) {
  const { onClose, step, setStep } = props;
  return (
    <Flex dir="column" gap="3xl" p="3xl">
      <Flex justify="space-between" py="sm">
        <Text fontSize="sm" fontWeight="semibold">
          Process return
        </Text>
        {onClose && (
          <div className={inspectorStyles.closeButton} onClick={onClose}>
            <XIcon height="16" width="16" />
          </div>
        )}
      </Flex>
      <Text fontSize="sm" textColor="secondary">
        Automatically process the return using the merchant's configured
        processing settings.
      </Text>
      <RedoToggle
        label="Send processing notification"
        setValue={(value) => setStep({ ...step, sendNotifications: value })}
        size="xs"
        value={step.sendNotifications ?? true}
      />
    </Flex>
  );
});

export const processReturnStepType: FrontendStepType<
  PartialWithRequiredType<ProcessReturnStep>
> = {
  type: "custom",
  valid: (state) => !!state.id,
  customInspector: ProcessReturnInspector,
};
